/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// React Router
import { Link } from 'react-router-dom';

const Item = ({ data }) => {
    if(data.externalLink == true) {
        return (
            <div className="flex items-center mb-2.5">
                <div>
                    <img src={data.icon} className="select-none w-8" alt="Icon" />
                </div>
                <div className="ml-5">
                    {data.linkType === 'route' ?
                        <Link to={data.link}>
                            <h1 className="text-sm text-gray-300 font-semibold">{data.name}</h1>
                        </Link>
                    :
                        <a href={data.link} target="_blank">
                            <h1 className="text-sm text-gray-300 font-semibold">{data.name}</h1>
                        </a>
                    }
                </div>
            </div>
        )
    } else {
        return (
            <div className="flex items-center mb-2.5">
                <div>
                    <img src={data.icon} className="select-none w-8" alt="Icon" />
                </div>
                <div className="ml-5">
                    {data.linkType === 'route' ?
                        <Link to={data.link}>
                            <h1 className="text-sm text-gray-300 font-semibold">{data.name}</h1>
                        </Link>
                    :
                        <a href={data.link}>
                            <h1 className="text-sm text-gray-300 font-semibold">{data.name}</h1>
                        </a>
                    }
                </div>
            </div>
        )
    }
}

export default Item